import { a as f, i as m } from "./type-BFTbooL7.js";
function i(e, n) {
  return function(t, a) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    const o = f(t) ? e(t) : void 0, s = f(a) ? e(a) : void 0;
    return o === s ? 0 : m(o) ? r * 1 : m(s) ? r * -1 : r * n(o, s);
  };
}
const p = i((e) => e, (e, n) => Number(e) - Number(n)), l = i((e) => e, (e, n) => e.localeCompare(n)), g = i((e) => e, (e, n) => e - n), C = i((e) => e, (e, n) => {
  const t = new Date(e), a = new Date(n);
  return t.getTime() - a.getTime();
}), w = (e, n, t, a) => t ? i((r) => r, (r, o) => {
  const s = t.toLowerCase(), c = r.toLowerCase().indexOf(s), u = o.toLowerCase().indexOf(s);
  return c === u || c === -1 && u === -1 ? r.localeCompare(o) : u === -1 ? -1 : c === -1 ? 1 : c - u;
})(e, n, a) : 0;
export {
  w as a,
  p as b,
  g as c,
  l as d,
  C as e
};
